import { CREATE_WATCH_LIST_ENTRY_EU_TERRORISTS } from '../types';
import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  createWatchListEntry,
  createWatchListEntryPending,
  createWatchListEntryFulfilled,
  createWatchListEntryRejected,
} = createAsyncActions(CREATE_WATCH_LIST_ENTRY_EU_TERRORISTS, 'createWatchListEntry');


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/actions/createWatchListEntryActions.js